import "@fontsource/quicksand/300.css";
import "@fontsource/eb-garamond/400.css";
import React from "react";
import ReactDOM from "react-dom";
import Page from "./containers/Page";
import Book from "./containers/Book";
import Cover from "./containers/Cover";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Auth } from "@aws-amplify/auth";
import { Storage } from "@aws-amplify/storage";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import styledNormalize from "styled-normalize";

const GlobalStyle = createGlobalStyle`
  ${reset}
  ${styledNormalize}
  @font-face {
    font-family: 'La Ronda';
    src: local('La Ronda'), 
        local('LaRonda'), 
        url('fonts/LaRonda-Regular.woff2') format('woff2'),
        url('fonts/LaRonda-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  * {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: subpixel-antialiased;
    text-transform: none;
    font-kerning: none;
    text-size-adjust: none;
  }
  /* Interactive editor affordances. The .editable markers are only attached
     in view=preview (see utils/editable.jsx), so the print/PDF and review
     DOM never carries them, and the hover styles are additionally gated
     behind the hover media query so touch devices and native WebViews never
     show them. Outlines never affect layout. */
  @media (hover: hover) and (pointer: fine) {
    .editable {
      cursor: pointer;
    }
    .editable:hover {
      outline: 2px solid rgba(64, 85, 119, 0.45);
      outline-offset: 2px;
    }
    .editable-photo-empty:hover > div {
      background-color: #b6bdcb;
    }
  }
  .editable.editable-selected,
  .editable.editable-selected:hover {
    outline: 2px solid #405577;
    outline-offset: 2px;
  }
  /* Photo drag-and-drop target highlight (class added/removed imperatively
     by Photo.jsx during dragover/dragleave/drop, view=preview only). Not
     behind the hover media query — HTML5 drags are mouse-driven anyway.
     The tint is an overlay so it shows above the slot's own image. */
  .editable.photo-drop-target,
  .editable.photo-drop-target:hover {
    outline: 3px dashed #405577;
    outline-offset: 2px;
    position: relative;
  }
  .editable.photo-drop-target::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(64, 85, 119, 0.15);
    z-index: 20000;
    pointer-events: none;
  }
`;

if (
  process.env.REACT_APP_AWS_IDENTITY_POOL_ID &&
  process.env.REACT_APP_AWS_REGION &&
  process.env.REACT_APP_AWS_USER_POOL_ID &&
  process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID &&
  process.env.REACT_APP_AWS_USER_FILES_BUCKET
) {
  Storage.configure({
    bucket: process.env.REACT_APP_AWS_USER_FILES_BUCKET,
    region: process.env.REACT_APP_AWS_REGION
  });
  Auth.configure({
    identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
  });
}

function AppRouter() {
  return (
    <Router>
      <GlobalStyle />
      <Switch>
        <Route exact path="/page" component={Page} />
        <Route exact path="/book" component={Book} />
        <Route exact path="/cover" component={Cover} />
      </Switch>
    </Router>
  );
}

ReactDOM.render(<AppRouter />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
